import { Directive, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { NavbarPortalService } from '../services/navbar-portal.service';

@Directive({
  selector: '[navbarCenterPortal]'
})
export class NavbarCenterPortalDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private navbarPortalService: NavbarPortalService
  ) {}

  ngOnInit(): void {
    this.navbarPortalService.setCenterPortal(this.templateRef);
  }

  ngOnDestroy(): void {
    this.navbarPortalService.setCenterPortal(null);
  }
}

@Directive({
  selector: '[navbarLeftPortal]'
})
export class NavbarLeftPortalDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private navbarPortalService: NavbarPortalService
  ) {}

  ngOnInit(): void {
    this.navbarPortalService.setLeftPortal(this.templateRef);
  }

  ngOnDestroy(): void {
    this.navbarPortalService.setLeftPortal(null);
  }
}

@Directive({
  selector: '[navbarRightPortal]'
})
export class NavbarRightPortalDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private navbarPortalService: NavbarPortalService
  ) {}

  ngOnInit(): void {
    this.navbarPortalService.setRightPortal(this.templateRef);
  }

  ngOnDestroy(): void {
    this.navbarPortalService.setRightPortal(null);
  }
}
